/* eslint-disable no-restricted-syntax */
export const productionEnv = process.env.NODE_ENV === 'production';

/**
 * This file attempts to consolidate the environment variables accessed by the
 * application. Anything that needs to be set at build time should be added
 * here.
 */

/** We should report 'local' unless the cluster is provided by k8s. */
export const CLUSTER_NAMESPACE = productionEnv
  ? window.env.CLUSTER_NAMESPACE
  : 'local';

export const COMSDOMAIN = productionEnv
  ? window.env.COMSDOMAIN
  : import.meta.env.VITE_COMSDOMAIN;
export const COMS_WS_URL = productionEnv
  ? window.env.COMS_WS_URL
  : import.meta.env.VITE_COMS_WS_URL;
export const AZURE_CLIENT_ID = productionEnv
  ? window.env.AZURE_CLIENT_ID
  : import.meta.env.VITE_AZURE_CLIENT_ID;
export const AZURE_API_SCOPE = productionEnv
  ? window.env.AZURE_API_SCOPE
  : import.meta.env.VITE_AZURE_API_SCOPE;
export const AZURE_API_AUDIENCE = productionEnv
  ? window.env.AZURE_API_AUDIENCE
  : import.meta.env.VITE_AZURE_API_AUDIENCE;

/**
 * TODO: We should rename this env var to AZURE_KNOWN_AUTHORITIES if it is
 * needed at all. It was for the IL5 EntraID work.
 */
export const AZURE_KNOWN_AUTHORITIES = productionEnv
  ? window.env.KNOWN_AUTHORITIES
  : import.meta.env.VITE_KNOWN_AUTHORITIES;
export const AZURE_AUTHORITY = productionEnv
  ? window.env.AZURE_AUTHORITY
  : import.meta.env.VITE_AZURE_AUTHORITY;
export const AUTH_0_CLIENT_ID = productionEnv
  ? window.env.AUTH_0_CLIENT_ID
  : import.meta.env.VITE_AUTH_0_CLIENT_ID;
export const AUTH_0_DOMAIN = productionEnv
  ? window.env.AUTH_0_DOMAIN
  : import.meta.env.VITE_AUTH_0_DOMAIN;
export const AUTH_0_AUDIENCE = productionEnv
  ? window.env.AUTH_0_AUDIENCE
  : import.meta.env.VITE_AUTH_0_AUDIENCE;
/** Options for specified auth providers: oidc, auth0, descope, msal (forced entra) */
export const BROWSER_AUTH_PROVIDER = productionEnv
  ? window.env.BROWSER_AUTH_PROVIDER
  : import.meta.env.VITE_BROWSER_AUTH_PROVIDER;
export const DESCOPE_PROJECT_ID = productionEnv
  ? window.env.DESCOPE_PROJECT_ID
  : import.meta.env.VITE_DESCOPE_PROJECT_ID;
export const DESCOPE_FLOW_ID = productionEnv
  ? window.env.DESCOPE_FLOW_ID
  : import.meta.env.VITE_DESCOPE_FLOW_ID;
export const DESCOPE_BASE_URL = productionEnv
  ? window.env.DESCOPE_BASE_URL
  : import.meta.env.VITE_DESCOPE_BASE_URL;
export const OIDC_ISSUER = productionEnv
  ? window.env.OIDC_ISSUER
  : import.meta.env.VITE_OIDC_ISSUER;
export const OIDC_CLIENT_ID = productionEnv
  ? window.env.OIDC_CLIENT_ID
  : import.meta.env.VITE_OIDC_CLIENT_ID;
export const OIDC_SCOPE = productionEnv
  ? window.env.OIDC_SCOPE
  : import.meta.env.VITE_OIDC_SCOPE;

export const SENTRY_DSN = productionEnv
  ? window.env.SENTRY_DSN
  : import.meta.env.VITE_SENTRY_DSN;

export const POSTHOG_HOST = productionEnv
  ? window.env.POSTHOG_HOST
  : import.meta.env.VITE_POSTHOG_HOST;

/** Local-only environment variables. */
export const NEW_USER_DEMO_SETTER_DOMAIN = import.meta.env
  .VITE_NEW_USER_DEMO_SETTER_DOMAIN;

/** Build-time environment variables. */
export const PLATFORM_VERSION = import.meta.env.VITE_PLATFORM_VERSION;
